import { Component } from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import Button from 'observian-ui/lib/button'
import scrollTo from 'gatsby-plugin-smoothscroll'
// import { gsap, Elastic } from 'gsap'
// import Button from 'observian-ui/lib/button'

import GoogleCloud from 'components/SVG/clouds/googleCloud'
import TechLines from 'components/SVG/techLines'
import ObservianLogoGateMSFT from 'components/SVG/observianLogoGateMSFT'

import style from './heroGoogle.module.css'

class PureHeroGoogle extends Component {
  state = {}

  componentDidMount() {}

  render() {
    const { data } = this.props

    return (
      <section className={style.hero}>
        <ObservianLogoGateMSFT
          className={style.observianLogoGate}
          firstSpin={style.firstSpin}
          secondSpin={style.secondSpin}
        />
        <span role="presentation" alt="Hero Background Left" className={style.topLeftBG} />
        <span role="presentation" alt="Hero Background Right" className={style.bottomRightBG} />
        <TechLines className={style.techLinesRight} />

        <div className={style.heroContent}>
          <div className={style.left}>
            <svg
              width="1108px"
              height="109px"
              viewBox="0 0 1108 109"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              className={style.beyondCloud}
            >
              <defs>
                <linearGradient
                  x1="12.4534884%"
                  y1="50.3378863%"
                  x2="87.8953488%"
                  y2="49.6742449%"
                  id="beyondGrad"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
              </defs>
              <g
                id="Managed-Service"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                opacity="0.7"
              >
                <path
                  d="M316.8,2 C333.6858,2 347.462786,7.46744772 357.133047,16.5130145 C367.258182,25.9840713 372.85,39.3524118 372.85,54.3 C372.85,69.4398092 367.285367,82.8582162 357.199455,92.3447071 C347.526165,101.443098 333.72426,106.9 316.8,106.9 C299.87574,106.9 286.073835,101.443098 276.400545,92.3447071 C266.314633,82.8582162 260.75,69.4398092 260.75,54.3 C260.75,39.3524118 266.341818,25.9840713 276.466953,16.5130145 C286.137214,7.46744772 299.9142,2 316.8,2 Z M316.8,29.35 C310.364769,29.35 305.370092,31.9441602 301.920371,36.2704496 C298.402056,40.6827631 296.5,46.9831154 296.5,54.3 C296.5,61.8177202 298.385257,68.1588271 301.864105,72.5786744 C305.316019,76.9643029 310.328664,79.55 316.8,79.55 C323.209457,79.55 328.235237,76.9531714 331.708474,72.5404519 C335.186502,68.1216458 337.1,61.7949251 337.1,54.3 C337.1,47.0051256 335.169336,40.7193436 331.651977,36.308229 C328.181145,31.9554652 323.173776,29.35 316.8,29.35 Z M672.6,2 C656.44804,2 643.01531,7.54858433 633.52178,16.6643874 C623.642187,26.1508937 618.05,39.478018 618.05,54.3 C618.05,69.9211636 623.635932,83.0021305 633.166639,92.2041923 C642.869361,101.572338 656.625017,106.9 672.6,106.9 C687.769376,106.9 697.840287,103.258112 706.030443,97.7865664 L696.315131,71.74953 C691.374561,75.5727459 684.796442,78.65 676.8,78.65 C670.233773,78.65 664.368422,76.1334572 660.196956,71.6938257 C656.251496,67.4947286 653.8,61.5508296 653.8,54.3 C653.8,47.2575339 656.240549,41.317934 660.253409,37.1044302 C664.370012,32.781997 670.160121,30.25 676.8,30.25 C684.330665,30.25 690.532748,32.7870249 695.611414,36.9264549 L705.418216,11.1190826 C697.463533,5.89203462 687.178412,2 672.6,2 Z M841.35,2 C858.2358,2 872.012786,7.46744772 881.683047,16.5130145 C891.808182,25.9840713 897.4,39.3524118 897.4,54.3 C897.4,69.4398092 891.835367,82.8582162 881.749455,92.3447071 C872.076165,101.443098 858.27426,106.9 841.35,106.9 C824.42574,106.9 810.623835,101.443098 800.950545,92.3447071 C790.864633,82.8582162 785.3,69.4398092 785.3,54.3 C785.3,39.3524118 790.891818,25.9840713 801.016953,16.5130145 C810.687214,7.46744772 824.4642,2 841.35,2 Z M841.35,29.35 C834.914769,29.35 829.920092,31.9441602 826.470371,36.2704496 C822.952056,40.6827631 821.05,46.9831154 821.05,54.3 C821.05,61.8177202 822.935257,68.1588271 826.414105,72.5786744 C829.866019,76.9643029 834.878664,79.55 841.35,79.55 C847.759457,79.55 852.785237,76.9531714 856.258474,72.5404519 C859.736502,68.1216458 861.65,61.7949251 861.65,54.3 C861.65,47.0051256 859.719336,40.7193436 856.201977,36.308229 C852.731145,31.9554652 847.723776,29.35 841.35,29.35 Z M941.2,3.95 L907.1,3.95 L907.1,65.7 C907.1,78.0651646 911.289573,88.5866014 919.449689,95.8850904 C927.285058,102.893123 938.718666,106.9 953.4,106.9 C968.162642,106.9 979.673589,102.888364 987.56575,95.8731102 C995.774991,88.5760063 1000,78.0595088 1000,65.7 L1000,3.95 L965.9,3.95 L965.9,66.6 C965.9,70.7484607 964.643752,73.8804946 962.580735,76.0319265 C960.39443,78.3119304 957.246262,79.55 953.4,79.55 C949.623925,79.55 946.548986,78.3077437 944.415827,76.0177352 C942.416311,73.8711958 941.2,70.7441044 941.2,66.6 L941.2,3.95 Z M45.45,3.95 C56.8055961,3.95 66.0479642,6.70186581 72.4651914,11.5829228 C78.7972109,16.3991693 82.3,23.295439 82.3,31.5 C82.3,39.3633341 79.4044438,45.5722575 72.368315,50.4009733 C71.303276,51.1318824 70.2428486,51.7628972 69.1862274,52.2977883 C70.3311805,52.7002321 71.4500192,53.1990396 72.5287141,53.7983146 C76.1711991,55.8219173 79.0828497,58.8393752 81.1124457,62.3085685 C83.237837,65.9415047 84.4,70.0736466 84.4,74.1 C84.4,83.8286431 80.9318051,91.4133618 74.840322,96.6041587 C68.3436989,102.140192 58.9564112,104.95 47.85,104.95 L47.85,104.95 L2,104.95 L2,3.95 Z M43.2,62.65 L34.6,62.65 L34.6,80.75 L43.2,80.75 C45.776195,80.75 48.0143765,79.7455659 49.6222839,78.1376585 C51.2597056,76.5002368 52.25,74.2255851 52.25,71.7 C52.25,69.1744149 51.2597056,66.8997632 49.6222839,65.2623415 C48.0143765,63.6544341 45.776195,62.65 43.2,62.65 Z M43.2,28 L34.6,28 L34.6,43.7 L43.2,43.7 C45.6877635,43.7 47.5568943,42.8112908 48.8690365,41.5319521 C50.4189569,40.0207797 51.2,37.9119112 51.2,35.85 C51.2,33.7880888 50.4189569,31.6792203 48.8690365,30.1680479 C47.5568943,28.8887092 45.6877635,28 43.2,28 Z M156.85,3.95 L95.3,3.95 L95.3,104.95 L156.85,104.95 L156.85,79.4 L129.25,79.4 L129.25,65.95 L153.85,65.95 L153.85,42.2 L129.25,42.2 L129.25,29.5 L156.85,29.5 L156.85,3.95 Z M205.283391,3.95 L167.921096,3.95 L199.4,61.5894538 L199.4,104.95 L233.5,104.95 L233.5,61.5894538 L264.978904,3.95 L229.116609,3.95 L217.2,37.8272172 L205.283391,3.95 Z M417.820878,3.95 L382.55,3.95 L382.55,104.95 L416.2,104.95 L416.2,48.5024275 L442.279122,104.95 L477.55,104.95 L477.55,3.95 L443.9,3.95 L443.9,60.3975725 L417.820878,3.95 Z M526.05,3.95 C543.181304,3.95 557.554426,8.72997091 567.545871,17.6481665 C577.202068,26.2671252 582.7,38.7372362 582.7,54.3 C582.7,69.7642829 577.188776,82.3724498 567.438871,91.1249223 C557.495432,100.05113 543.20649,104.95 526.05,104.95 L526.05,104.95 L490.55,104.95 L490.55,3.95 Z M527.7,29.95 L523.45,29.95 L523.45,78.95 L527.7,78.95 C534.004001,78.95 539.159092,76.7186157 542.706398,72.2918122 C545.935108,68.2625958 547.85,62.3154982 547.85,54.3 C547.85,46.2994305 545.941282,40.4351207 542.728729,36.4791663 C539.183301,32.1133095 534.02216,29.95 527.7,29.95 Z M751.6,3.95 L717.5,3.95 L717.5,104.95 L780.4,104.95 L780.4,79.4 L751.6,79.4 L751.6,3.95 Z M1048.5,3.95 C1065.6313,3.95 1080.00443,8.72997091 1089.99587,17.6481665 C1099.65207,26.2671252 1105.15,38.7372362 1105.15,54.3 C1105.15,69.7642829 1099.63878,82.3724498 1089.88887,91.1249223 C1079.94543,100.05113 1065.65649,104.95 1048.5,104.95 L1048.5,104.95 L1013,104.95 L1013,3.95 Z M1050.15,29.95 L1045.9,29.95 L1045.9,78.95 L1050.15,78.95 C1056.454,78.95 1061.60909,76.7186157 1065.1564,72.2918122 C1068.38511,68.2625958 1070.3,62.3154982 1070.3,54.3 C1070.3,46.2994305 1068.39128,40.4351207 1065.17873,36.4791663 C1061.6333,32.1133095 1056.47216,29.95 1050.15,29.95 Z"
                  id="BEYONDCLOUD"
                  stroke="url(#beyondGrad)"
                  strokeWidth="4"
                  fillRule="nonzero"
                />
              </g>
            </svg>
            <div className={style.title}>Managed GCP Services</div>
            <svg
              width="169px"
              height="8px"
              viewBox="0 0 169 8"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              className={style.underline}
            >
              <defs>
                <linearGradient
                  x1="-5.30225943%"
                  y1="50.2639529%"
                  x2="52.3022132%"
                  y2="49.7972327%"
                  id="linearGradient-1"
                >
                  <stop stopColor="#1D8DBA" offset="0%" />
                  <stop stopColor="#03ECAE" offset="100%" />
                </linearGradient>
              </defs>
              <g
                id="Managed-Service"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                opacity="0.188290551"
              >
                <polygon
                  id="Path-103"
                  fill="url(#linearGradient-1)"
                  points="0 0 73.546875 2.3125 168.910156 6.15625 73.9534945 5.34487062 5.15283162 7.65517943"
                />
              </g>
            </svg>
            <div className={style.introText}>
              We understand that finding and retaining cloud talent can be difficult, which is why
              we’ve put together a team of dedicated experts for you. With our managed cloud, you
              get access to an entire team of specialists in Engineering, Architecture and Security.
              With eight hours of professional services included in each month (discounted hourly
              rates after that) and quarterly architecture reviews, you will be sure that you are
              getting the most out of your cloud while keeping costs to a minimum.
            </div>
            <div className={style.buttons}>
              <Button
                varient="primary"
                outline
                label="Managed Google Cloud"
                onClick={() => scrollTo('#managedCloud')}
              />
              <Button
                varient="primary"
                outline
                label="Managed Security"
                onClick={() => scrollTo('#managedSecurity')}
              />
            </div>
            <GoogleCloud />
          </div>
          <div className={style.right}>
            <span className={style.spaceman}>
              <GatsbyImage image={data.spaceman.childImageSharp.gatsbyImageData} alt="" />
              <span className={style.googpartner}>
                <GatsbyImage
                  image={data.googpartner.childImageSharp.gatsbyImageData}
                  style={{ width: '80%' }}
                  alt=""
                />
              </span>
            </span>
          </div>
        </div>
        <svg
          width="440px"
          height="46px"
          viewBox="0 0 440 46"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          className={style.laser}
        >
          <defs>
            <linearGradient
              x1="12.4534884%"
              y1="50.1067999%"
              x2="87.8953488%"
              y2="49.8970346%"
              id="linearGradient-12"
            >
              <stop stopColor="#1D8DBA" offset="0%" />
              <stop stopColor="#03ECAE" offset="100%" />
            </linearGradient>
            <filter
              x="-3.5%"
              y="-62.5%"
              width="106.9%"
              height="225.0%"
              filterUnits="objectBoundingBox"
              id="filter-221"
            >
              <feGaussianBlur stdDeviation="5" in="SourceGraphic" />
            </filter>
          </defs>
          <g id="Managed-Service" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              id="Group-30"
              transform="translate(4.000000, -8.000000)"
              fill="url(#linearGradient-12)"
            >
              <polygon
                id="Path-129-Copy"
                filter="url(#filter-221)"
                transform="translate(218.000000, 28.000000) rotate(-4.000000) translate(-218.000000, -28.000000) "
                points="1 24.6417773 89.2226812 16 223.344729 33.7681875 435 33.7681875 186.120781 40 101.766645 20.6856669"
              />
              <polygon
                id="Path-129"
                transform="translate(218.000000, 28.000000) rotate(-1.000000) translate(-218.000000, -28.000000) "
                points="1 24.6417773 89.2226812 16 223.344729 33.7681875 435 33.7681875 186.120781 40 101.766645 20.6856669"
              />
            </g>
          </g>
        </svg>
        <svg viewBox="0 0 1442 113" width="100%" className={style.svgDivider}>
          <path
            d="M.836 12.25l188.413 8.763L371.85 0c299.337 47.876 449.285 72.006 449.845 72.388.56.382 101.73-8.706 303.507-27.266l244.683 35.902 72.018-22.654V113H.836V12.25z"
            fill="#FFF"
          />
        </svg>
      </section>
    )
  }
}
PureHeroGoogle.defaultProps = {
  data: {},
}

PureHeroGoogle.propTypes = {
  data: PropTypes.object,
}

const query = graphql`
  {
    spaceman: file(relativePath: { eq: "services/managed/spaceman.png" }) {
      childImageSharp {
        gatsbyImageData(width: 458, placeholder: TRACED_SVG, layout: CONSTRAINED)
      }
    }
    googpartner: file(relativePath: { eq: "services/google/premier-gcp-partner.png" }) {
      childImageSharp {
        gatsbyImageData(width: 250, placeholder: TRACED_SVG, layout: CONSTRAINED)
      }
    }
  }
`

export const HeroGoogle = (props) => (
  <StaticQuery query={query} render={(data) => <PureHeroGoogle data={data} {...props} />} />
)

export default HeroGoogle
